import { Dialog, makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import { FC } from "react"
import { NudgeDomain } from "../../utils/constants"
import { TechniqueListWithPercentage } from "./TechniqueListWithPercentage"
import { colors } from "../../utils/theme"
import CloseIcon from "../atoms/CloseIcon"

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    border: `1px solid ${colors.neutral.clay}`,
    boxShadow: "none",
  },
  dialogCloseContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(1),
  },
  dialogContent: {
    padding: theme.spacing(5),
    paddingTop: theme.spacing(2),
  },
  closeButton: {
    margin: 0,
    padding: 0,
    border: 0,
    height: theme.spacing(2),
    width: theme.spacing(2),
    backgroundColor: "transparent",
    cursor: "pointer",
    "&:focus": {
      outline: "none",
    },
  },
  dialogTitle: {
    color: colors.neutral.denim,
    marginBottom: 12,
  },
  dialogSubtitle: {
    color: colors.neutral.denim,
    marginBottom: theme.spacing(3),
  },
  dialogInput: {
    width: "100%",
    marginBottom: theme.spacing(3),
  },
  dialogButton: {
    width: "100%",
  },
  cancelContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  changingRoleText: {
    color: colors.neutral.denim,
    textAlign: "center",
  },
  changingRoleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 64,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    backgroundColor: colors.secondary.blush,
    borderRadius: 4,
    marginBottom: theme.spacing(3),
  },
  editTitle: {
    marginBottom: theme.spacing(3),
  },
}))

export const ViewAllTechniquesDialog: FC<{
  open: boolean
  onClose: () => void
  techniques:
    | {
        label: string
        domain: NudgeDomain
        percent: number
        active?: boolean
      }[]
    | undefined
  percentMultiplier: number
}> = ({ open, onClose, techniques, percentMultiplier }) => {
  const classes = useStyles()
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      classes={{
        paper: classes.dialogPaper,
      }}
    >
      <div className={classes.dialogContent}>
        <div className={classes.dialogCloseContainer}>
          <button className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <Typography variant="h3" className={clsx(classes.dialogTitle)}>
          All Intervention Techniques
        </Typography>
        <TechniqueListWithPercentage
          techniques={techniques}
          percentMultiplier={percentMultiplier}
        />
      </div>
    </Dialog>
  )
}
